<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            Type of Insurance + Enrolment Category Mapping
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <form id="saveForm" @submit.prevent="save"></form>
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="action-column">Action</th>
                <th style="width: 50%">Type of Insurance</th>
                <th style="width: 20%">Enrolment Category</th>
                <th class="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, i) in insuranceCategoryMapping"
                :key="i"
                :class="!item.IsActive ? 'disabled-color' : ''"
              >
                <template v-if="editIndex !== i">
                  <td>
                    <label class="toggler">
                      <input
                        type="checkbox"
                        v-model="item.IsActive"
                        @change="toggle(item, $event)"
                      />
                      <span class="slider round"></span>
                    </label>
                    <button
                      v-if="item.IsActive"
                      class="btn pb-0"
                      title="Edit"
                      @click="edit(item, i)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                  </td>
                  <td>{{ item.InsuranceTypeDesc }}</td>
                  <td>{{ item.EnrolmentCategoryDesc }}</td>
                  <td class="text-center">{{ item.AmountDisplay }}</td>
                </template>
                <template v-else>
                  <td class="text-center table-info">
                    <button
                      type="button"
                      class="btn"
                      title="Save"
                      @click="save"
                    >
                      <i class="fa fa-save"></i>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      title="Cancel"
                      @click="cancel"
                    >
                      <i class="fa fa-window-close-o"></i>
                    </button>
                  </td>
                  <td class="table-info">{{ item.InsuranceTypeDesc }}</td>
                  <td class="table-info">{{ item.EnrolmentCategoryDesc }}</td>
                  <td class="table-info">
                    <input
                      type="number"
                      class="form-control"
                      v-model="formData.amount"
                      step=".01"
                      min="0"
                      max="999999"
                      required
                    />
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      insuranceCategoryMapping: [],
      formData: {
        id: "",
        insuranceTypeId: "",
        enrolmentCategoryId: "",
        amount: 0,
        isActive: false,
      },
      editIndex: -1,
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getInsuranceCategoryMapping() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMapping(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.insuranceCategoryMapping = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //action
    resetForm() {
      this.formData = {
        id: "",
        insuranceTypeId: "",
        enrolmentCategoryId: "",
        amount: "",
      };
    },
    edit(payload, rowIndex) {
      this.editIndex = rowIndex;
      this.resetForm();
      this.formData.id = payload.Id;
      this.formData.insuranceTypeId = payload.InsuranceTypeId;
      this.formData.enrolmentCategoryId = payload.EnrolmentCategoryId;
      this.formData.amount = payload.Amount;
    },
    cancel() {
      this.editIndex = -1;
      this.resetForm();
      this.getInsuranceCategoryMapping();
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.formData.id,
        InsuranceTypeId: this.formData.insuranceTypeId,
        EnrolmentCategoryId: this.formData.enrolmentCategoryId,
        Amount: this.formData.amount,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveInsuranceCategoryMapping(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },

    toggle(payload, $event) {
      let isActive = $event.target.checked;
      let param = {
        Token: this.token,
        Id: payload.Id,
        InsuranceTypeId: payload.InsuranceTypeId,
        EnrolmentCategoryId: payload.EnrolmentCategoryId,
        IsActive: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleInsuranceCategoryMapping(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.cancel();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },

  created() {
    if (this.role != "admin")
      this.$router.replace({ name: "home" });
    else this.getInsuranceCategoryMapping();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Insurance/InsuranceCategoryMapping.vue